import {
  doc,
  getDocFromServer,
  runTransaction,
  Timestamp,
} from "firebase/firestore";
import { db } from "../../firebase";
import { BUILD_ID } from "../../generated/buildInfo";
import { isNewerBuildAvailable, shouldSelfBump } from "./versionGateCore";

// アプリの公開バージョンを保持する単一ドキュメント。
// build_id(number)はビルド時刻のエポックms(scripts/stamp-build-info.js が埋め込む)。
// firestore.rulesでbuild_idの厳密増加のみ許可しているため巻き戻しは起きない。
export const APP_CONFIG_COLLECTION = "app_config";
export const VERSION_DOC_ID = "version";

export const getVersionRef = () => doc(db, APP_CONFIG_COLLECTION, VERSION_DOC_ID);

// 旧ビルドのタブが注文系の書き込みをしようとしたことを表すエラー
export class StaleBuildError extends Error {
  constructor() {
    super("STALE_BUILD");
    this.name = "StaleBuildError";
  }
}

// 新ビルドの初回ロード時にバージョンdocを前方単調に進める(セルフバンプ)。
// デプロイ後、新ビルドを最初に開いた利用者のタブが自動で発火するため、
// デプロイスクリプトや管理者の手作業は不要。
export const selfBumpVersion = async () => {
  await runTransaction(db, async (transaction) => {
    const snap = await transaction.get(getVersionRef());
    const serverBuildId = snap.exists() ? snap.data().build_id : null;
    if (!shouldSelfBump(serverBuildId, BUILD_ID)) {
      return;
    }
    transaction.set(getVersionRef(), {
      build_id: BUILD_ID,
      updated_at: Timestamp.now(),
    });
  });
};

// サーバへ直接問い合わせて新ビルド公開の有無を返す。
// タブ復帰・フォーカス時の強制確認用(ローカルキャッシュを見ない)。
export const fetchIsUpdateAvailable = async () => {
  const snap = await getDocFromServer(getVersionRef());
  return snap.exists() && isNewerBuildAvailable(snap.data().build_id, BUILD_ID);
};

// トランザクション内で読んだバージョンdocから「このタブのビルドは古い」を判定する
export const isStaleBuildSnap = (versionSnap) =>
  versionSnap != null &&
  versionSnap.exists() &&
  isNewerBuildAvailable(versionSnap.data().build_id, BUILD_ID);

// トランザクションの冒頭で呼び、古いビルドならStaleBuildErrorで中止する。
// (Firestoreのトランザクションは読み取りを書き込みより先に行う必要がある)
export const assertFreshBuildInTransaction = async (transaction) => {
  const snap = await transaction.get(getVersionRef());
  if (isStaleBuildSnap(snap)) {
    throw new StaleBuildError();
  }
};
